import { Component, OnInit } from '@angular/core';

import { AccountComponent } from '../../account/account/account.component';
import { PolicyComponent } from '../../policy/policy.component';
import { NavigationService } from '../../core/services/navigation.service';

@Component({
  selector: 'dx-billing-transactions-tab',
  templateUrl: './billing-transactions-tab.component.html',
  styleUrls: ['./billing-transactions-tab.component.scss']
})
export class BillingTransactionsTabComponent implements OnInit {
  accountNumber: string;
  policyNumber: string;

  constructor(private navigationService: NavigationService) {}

  ngOnInit() {
    let route = this.navigationService.getRouteByComponent(AccountComponent);

    if (!route) {
      route = this.navigationService.getRouteByComponent(PolicyComponent);
    }

    if (route) {
      route.paramMap.subscribe((params) => {
        this.accountNumber = params.get('accountNumber');
        this.policyNumber = params.get('policyNumber');
      });
    }
  }
}
